import {ofType} from 'redux-observable';
import {concat, iif, of} from 'rxjs';
import {catchError, delay, filter, mergeMap, timeout} from 'rxjs/operators';
import {ajax} from 'rxjs/ajax';
import * as CRValidationIdActions from '../../../actions/CRValidationIdActions';
import {AnyAction} from 'redux';
import * as UIActions from '../../../actions/UIActions';
import * as FileTypeConstants from '../../../../common/constants/FileTypeConstants';
import {addCredentialAndExecute} from '../../../utils/RetryUtil';
import * as MC from '../../../constants/MotorcreditConstants';
import {processApiError} from '../../../utils/ApiUtil';
import {COUNTRIES} from '../../../constants/AppConstants';
import {mapUpdateReportValidationIdStateToApi, mapValidateIDStateToApi} from '../../../utils/WizardMXBodyMapper';
import {BankTarget} from '../../../types/mx/types';
import * as ModalActions from '../../../actions/ModalActions';
import {MODAL_TYPE} from '../../../constants/ModalConstants';

export const onCrShouldSendToIdValidationEpic = (action$, state$) =>
    action$.pipe(
        ofType(CRValidationIdActions.CR_SHOULD_SEND_TO_ID_VALIDATION_ACTION.name),
        filter((action: AnyAction) => {
            const state = state$.value;
            const files = state[action.bank].loanApplication.files;
            const ifeFrontFiles = files.identification.ifeFrontFiles;
            const ifeBackFiles = files.identification.ifeBackFiles;
            const isIFE = action.fileType === FileTypeConstants.IDENTIFICATION_TYPE;
            return false; // isIFE && ifeFrontFiles.length > 0 && ifeBackFiles.length > 0;
        }),
        mergeMap((action: AnyAction) => {
            const state = state$.value;
            const bank = action.bank;
            const url = `${MC.VALIDATION_ID_URL}/validateID`;
            const body = mapValidateIDStateToApi(state, action);
            const loanApplicationToken = state[action.bank].loanApplication.token;
            console.log('----------------url----------------', url, body);
            /*return concat(
                of(CRValidationIdActions.CR_VERIFY_VALIDATION_ID_RESPONSE_ACTION.action(loanApplicationToken)),
            );*/
            return concat(
                of(
                    UIActions.IS_LOADING_ACTION.action(
                        CRValidationIdActions.CR_SHOULD_SEND_TO_ID_VALIDATION_ACTION.name
                    )
                ),
                addCredentialAndExecute(headers => ajax.post(url, body, headers),
                    state,
                    false,
                    'application/json',
                    MC.LAMBDA_API_GATEWAY_TOKEN).pipe(
                    timeout(MC.TIMEOUT),
                    mergeMap(({response, refreshTokenObs}: any) => {
                        console.log('----------------response----IDENTITY_VALIDATE_ID_ACTION------------',
                            response.response);
                        return concat(
                            of(refreshTokenObs),
                            of(
                                UIActions.IS_LOADED_ACTION.action(
                                    CRValidationIdActions.CR_SHOULD_SEND_TO_ID_VALIDATION_ACTION.name)
                            ),
                        );
                    }),
                    catchError((error) => {
                        console.log('----------------error-----IDENTITY_VALIDATE_ID_ACTION-----------', error);
                        return processApiError([
                            UIActions.IS_LOADED_ACTION.action(
                                CRValidationIdActions.CR_SHOULD_SEND_TO_ID_VALIDATION_ACTION.name
                            ),
                            UIActions.ERROR_GENERAL_ACTION.action(error, action, url, body, 'POST')
                        ])(error);
                    })
                )
            );
        })
    );

export const onCrReSendCurpToIdValidationEpic = (action$, state$) =>
    action$.pipe(
        ofType(CRValidationIdActions.CR_RESEND_CURP_TO_ID_VALIDATION_ACTION.name),
        mergeMap((action: AnyAction) => {
            const state = state$.value;
            const bank = action.bank;
            const url = `${MC.VALIDATION_ID_URL}/updateReportValidationId`;
            const body = mapUpdateReportValidationIdStateToApi(state, action);
            console.log('----------------url----------------', url, body);
            /*return concat(
                of(CRValidationIdActions.CR_VERIFY_VALIDATION_ID_RESPONSE_ACTION.action(action.loanApplicationToken)),
            );*/
            return concat(
                of(
                    UIActions.IS_LOADING_ACTION.action(
                        CRValidationIdActions.CR_RESEND_CURP_TO_ID_VALIDATION_ACTION.name
                    )
                ),
                addCredentialAndExecute(headers => ajax.post(url, body, headers),
                    state,
                    false,
                    'application/json',
                    MC.LAMBDA_API_GATEWAY_TOKEN).pipe(
                    timeout(MC.TIMEOUT),
                    mergeMap(({response, refreshTokenObs}: any) => {
                        console.log('----------------response----IDENTITY_VALIDATE_ID_ACTION------------',
                            response.response);
                        return concat(
                            of(refreshTokenObs),
                            of(
                                UIActions.IS_LOADED_ACTION.action(
                                    CRValidationIdActions.CR_RESEND_CURP_TO_ID_VALIDATION_ACTION.name)
                            ),
                            of(
                                CRValidationIdActions.CR_VERIFY_VALIDATION_ID_RESPONSE_ACTION.action(
                                    action.loanApplicationToken
                                )
                            ),
                        ).pipe(delay(5000));
                    }),
                    catchError((error) => {
                        console.log('----------------error-----RESEND_CURP_TO_ID_VALIDATION_ACTION-----------', error);
                        return processApiError([
                            UIActions.IS_LOADED_ACTION.action(
                                CRValidationIdActions.CR_RESEND_CURP_TO_ID_VALIDATION_ACTION.name
                            ),
                            UIActions.ERROR_GENERAL_ACTION.action(error, action, url, body, 'POST')
                        ])(error);
                    })
                )
            );
        })
    );

export const onCrVerifyValidationIdResponseEpic = (action$, state$) =>
    action$.pipe(
        ofType(CRValidationIdActions.CR_VERIFY_VALIDATION_ID_RESPONSE_ACTION.name),
        mergeMap((action: AnyAction) => {
            const urlBaseWithBank = MC.MCC_URL_WITH_BANK(COUNTRIES.MX.id, BankTarget.CREDITO_REAL);
            const url = `${urlBaseWithBank}/loan-applications-dealer/${action.token}/applicant-summary`;
            console.log('----------------url--CR_VERIFY_VALIDATION_ID_RESPONSE_ACTION--------------', url);
            return concat(
                of(UIActions.IS_LOADING_ACTION.action(
                    CRValidationIdActions.CR_VERIFY_VALIDATION_ID_RESPONSE_ACTION.name
                )),
                addCredentialAndExecute(headers => ajax.get(url, headers), state$.value).pipe(
                    timeout(MC.TIMEOUT),
                    mergeMap(({response, refreshTokenObs}: any) => {
                        console.log('----------------response----------------', response.response.data);
                        const validationId = response.response.data.validationId;
                        const validationIdGlobalResult = validationId.globalResult;
                        return  concat(
                            of(refreshTokenObs),
                            of(UIActions.IS_LOADED_ACTION.action(
                                CRValidationIdActions.CR_VERIFY_VALIDATION_ID_RESPONSE_ACTION.name
                            )),
                            of(ModalActions.CLOSE_MODAL_ACTION.action()),
                            iif(
                                () => validationIdGlobalResult === 0,
                                concat(
                                    of(
                                        ModalActions.OPEN_MODAL_DATA_ACTION.action(null, {
                                            type: MODAL_TYPE.VALIDATION_ID_WAITING_RESPONSE},
                                            null,
                                            {
                                                closeOnOverlayClick: false,
                                                size: 'small'
                                            }
                                        )
                                    ),
                                    of(action).pipe(delay(10000)),
                                ),
                                iif(
                                    () => validationIdGlobalResult === 2 || validationIdGlobalResult === 1,
                                    concat(
                                        of(
                                            ModalActions.OPEN_MODAL_DATA_ACTION.action(null, {
                                                type: MODAL_TYPE.VALIDATION_ID_SUCCESS},
                                                null,
                                                {
                                                    closeOnOverlayClick: true,
                                                    size: 'small'
                                                }
                                            )
                                        ),
                                    ),
                                    iif(
                                        () => validationIdGlobalResult === -2,
                                        concat(
                                            of(
                                                ModalActions.OPEN_MODAL_DATA_ACTION.action(null, {
                                                    type: MODAL_TYPE.VALIDATION_ID_CURP_ERROR_CR,
                                                    data: {
                                                        token: validationId.token,
                                                        loanApplicationToken: action.token,
                                                    }},
                                                    null,
                                                    {
                                                        closeOnOverlayClick: false,
                                                        size: 'small'
                                                    }
                                                )
                                            ),
                                        ),
                                        concat(
                                            of(
                                                ModalActions.OPEN_MODAL_DATA_ACTION.action(null, {
                                                    type: MODAL_TYPE.VALIDATION_ID_ERROR,
                                                    data: {
                                                        message: validationId.globalResultMessage,
                                                    }},
                                                    null,
                                                    {
                                                        closeOnOverlayClick: true,
                                                        size: 'small'
                                                    }
                                                )
                                            ),
                                        ),
                                    ),
                                ),
                            ),
                        );
                    }),
                    catchError((error) => {
                        console.log('entraaa a error GOT_LOAN_APPLICATION_SUMMARY-------------: ', error);
                        return processApiError([
                            of(UIActions.IS_LOADED_ACTION.action(
                                CRValidationIdActions.CR_VERIFY_VALIDATION_ID_RESPONSE_ACTION.name
                            )),
                            UIActions.ERROR_GENERAL_ACTION.action(error, action, url, {}, 'GET')
                        ])(error);
                    })
                )
            );
        })
);
